module.exports = __webpack_public_path__ + "img/gold3.5bbb7169.png";